import { render } from "./MenuItem.vue?vue&type=template&id=96bc1014"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96bc1014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96bc1014', __exports__)) {
    api.reload('96bc1014', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=96bc1014", () => {
    api.rerender('96bc1014', render)
  })

}


export default __exports__